import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

// Exact icon paths from the Claude Design InvoiceActionsMenu
// (ds-components/InvoiceActionsMenu.jsx): 24px viewBox, 1.7 stroke, no fill.
// The row-action menu sets the 17px size and the item colour.
const designIcon = (displayName: string, paths: React.ReactNode) => {
  const Icon = (props: SvgIconProps) => (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={[
        {
          fill: "none",
          stroke: "currentColor",
          strokeWidth: 1.7,
          strokeLinecap: "round",
          strokeLinejoin: "round",
        },
        ...(Array.isArray(props.sx) ? props.sx : props.sx ? [props.sx] : []),
      ]}
    >
      {paths}
    </SvgIcon>
  );
  Icon.displayName = displayName;
  return Icon;
};

export const InvoiceCircleDollarSignIcon = designIcon("InvoiceCircleDollarSignIcon", <>
  <circle cx="12" cy="12" r="9" />
  <path d="M14.2 9.5a2 2 0 0 0-1.9-1.2h-.6a1.8 1.8 0 0 0 0 3.5h.6a1.8 1.8 0 0 1 0 3.6h-.6a2 2 0 0 1-1.9-1.2M12 7v10" />
</>);

export const InvoiceFileDownIcon = designIcon("InvoiceFileDownIcon", <>
  <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
  <path d="M14 3v5h5M12 12v5M9.5 14.5 12 17l2.5-2.5" />
</>);

export const InvoiceMailIcon = designIcon("InvoiceMailIcon", <>
  <rect x="3" y="5" width="18" height="14" rx="2" />
  <path d="m3.5 6.5 8.5 6 8.5-6" />
</>);

export const InvoiceCircleXIcon = designIcon("InvoiceCircleXIcon", <>
  <circle cx="12" cy="12" r="9" />
  <path d="m9 9 6 6M15 9l-6 6" />
</>);

export const InvoicePencilIcon = designIcon("InvoicePencilIcon", <path d="M17 3.5a2.1 2.1 0 0 1 3 3L8 18.5l-4 1 1-4z" />);

export const InvoiceTrashIcon = designIcon("InvoiceTrashIcon", <>
  <path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  <path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M10 11v6M14 11v6" />
</>);

export const InvoiceRotateCcwIcon = designIcon("InvoiceRotateCcwIcon", <>
  <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
  <path d="M3 3v5h5" />
</>);

export const InvoiceCircleCheckIcon = designIcon("InvoiceCircleCheckIcon", <>
  <circle cx="12" cy="12" r="9" />
  <path d="m8.5 12.2 2.4 2.4 4.6-4.8" />
</>);
